(function() {
    'use strict';

    angular
        .module('app')
        .controller('UploadImageController', UploadImageController);

    UploadImageController.$inject = ['$http', '$scope'];

    function UploadImageController($http, $scope){
        var vm = this;
        vm.uploadImage = uploadImage;
        vm.deleteImage = deleteImage;
        vm.cancel = cancel;
        vm.getUrl = getUrl;
        vm.isState = isState;
        vm.rotate = rotate;

        vm.myImage='';
        vm.myCroppedImage='';
        vm.myCroppedImageArray=[];

        vm.states = {
            noImage:'noImage',
            previousImage:'previousImage',
            cropping:'cropping',
            saved:'saved'
        };
        vm.state = vm.states.noImage;

        vm.$onInit = function () {
            vm.decached = Math.random();
            vm.size = vm.size === undefined ? 'md' : vm.size;

            setTimeout(function(){
                imageExists(true);
                vm.imageSizes = vm.options && vm.options.square ? [{w:1920,h:1920},{w:640,h:640},{w:240,h:240}] : [{w:1920,h:1280},{w:640,h:426},{w:240,h:160}];
                vm.aspectRatio = vm.options && vm.options.square ? 1 : 1.5;
                vm.areaType = vm.options && vm.options.square ? 'circle' : 'rectangle';
                angular.element(document.querySelector('#fileInput-'+vm.imageNumber+'-1')).on('change',handleFileSelect);
                $scope.$applyAsync();
            }, 200)
        }

        function isState(state) {
            return vm.state === state;
        }

        vm.isLoading = false;
        function rotate(isClockwise) {
            return new Promise(function(resolve,reject) {
                if (!vm.myImage) {
                    return;
                }
                vm.isLoading = true;
                $scope.$applyAsync();
                rotateBase64Image(vm.myImage, isClockwise, function(result) {
                    $scope.$applyAsync(function() {  // $apply is required because we were called back outside of angular system
                        vm.myImage = result;
                        resolve();
                    });
                });
            });

        }
        vm.loading = function(loading) {
            if(loading == false) {
                setTimeout(function(){
                    if(vm.myCroppedImageArray[0].dataURI != "") {
                        vm.isLoading = loading;
                        $scope.$applyAsync();
                    } else {
                        vm.loading(false);
                    }
                },100);
            } else {
                vm.isLoading = loading;
                $scope.$applyAsync();
            }

        }

        function rotateBase64Image(base64data, isClockwise, callback) {
            var image = new Image();
            image.onload = function() {
                var canvas = document.createElement('canvas');
                canvas.width = image.height;
                canvas.height = image.width;
                var ctx = canvas.getContext("2d");
                var deg = isClockwise ? Math.PI / 2 : Math.PI / -2;
                // translate to center-canvas
                // the origin [0,0] is now center-canvas
                ctx.translate(canvas.width / 2, canvas.height / 2);
                // roate the canvas by +90% (==Math.PI/2)
                ctx.rotate(deg);
                // draw the signature
                // since images draw from top-left offset the draw by 1/2 width & height
                ctx.drawImage(image, -image.width / 2, -image.height / 2);
                // un-rotate the canvas by -90% (== -Math.PI/2)
                ctx.rotate(-deg);

                // un-translate the canvas back to origin==top-left canvas
                ctx.translate(-canvas.width / 2, -canvas.height / 2);
                callback(canvas.toDataURL("image/jpeg"));
            };
            //image.crossOrigin = "Anonymous";
            image.src = base64data;
        }

        function handleFileSelect(evt) {
            var file=evt.currentTarget.files[0];
            vm.isLoading = true;
            $scope.$applyAsync();
            window.loadImage(file, { maxWidth: 1920, meta: true, orientation: true, canvas: true }).then(function (data) {
                vm.state = vm.states.cropping;
                vm.isLoading = false;
                vm.myImage = data.image.toDataURL();
                $scope.$applyAsync();
            });
        };

        function uploadImage(){
            if(vm.isLoading || vm.upload_loading) {
                return;
            }
            vm.upload_loading = true;
            var formdata = new FormData();
            formdata.append('image_data_xl', vm.myCroppedImageArray[0].dataURI);
            formdata.append('image_data_md', vm.myCroppedImageArray[1].dataURI);
            formdata.append('image_data_xs', vm.myCroppedImageArray[2].dataURI);
            formdata.append('image_hash', vm.imageHash?vm.imageHash:null);

            $http.post('api/newupload/'+vm.type+'/'+vm.imageNumber+'/'+vm.slug+'/'+vm.tempSlug, formdata, {headers: {'Content-Type': undefined}})
            .then(function(response){
                vm.upload_loading = false;
                if(response.data.image_hash && !response.data.temp_slug){
                    vm.decached = Math.random();
                    vm.imageHash = response.data.image_hash;
                    if(!vm.image_exists) {
                        emitNewImageUpload();
                    }
                    imageExists();
                } else if(response.data == 'File too large'){
                    alert('File upload failed: File too large');
                } else if(response.data && response.data.temp_slug){
                    vm.imageHash = response.data.image_hash;
                    vm.tempSlug = response.data.temp_slug;
                    vm.decached = Math.random();
                    emitUploadedTempImage();
                    if(!vm.image_exists) {
                        emitNewImageUpload();
                    }
                    imageExists();

                }
            })
            .catch(function(){
                alert('File upload failed');
            });
        }

        function deleteImage(){
            var query = '';
            if(vm.tempSlug){
                query = '?temp_slug='+vm.tempSlug;
            }

            var formdata = new FormData();
            formdata.append('image_hash', vm.imageHash);

            $http.delete('api/newupload/'+vm.type+'/'+vm.imageHash+'/'+vm.slug+'/'+query, {headers: {'Content-Type': undefined}})
            .then(function(response){
                vm.state = vm.states.noImage;
                vm.imageHash = null;
                vm.image_exists = false;
                emitUploadedImageDeleted();
                document.querySelector('#fileInput-'+vm.imageNumber+'-1').value = '';
            })
            .catch(function(){
                alert('File delete failed');
            });
        }

        function cancel() {
            vm.state = vm.image_exists ? vm.states.previousImage : vm.states.noImage;
            document.querySelector('#fileInput-'+vm.imageNumber+'-1').value = '';
            //document.querySelector('#fileInput-'+vm.imageNumber+'-2').value = '';
            event.stopPropagation();
        }

        function getUrl(){
            var url = '';
            if(vm.tempSlug){
                url = '/uploads/temp_uploads/'+vm.tempSlug+'/'+vm.imageHash+'_'+vm.size+'.jpeg?decache='+vm.decached;
            } else {
                url = '/uploads/'+vm.type+'/'+vm.slug+'/'+vm.imageHash+'_'+vm.size+'.jpeg?decache='+vm.decached;
            }
            return url;
        }

        function imageExists(init){
            if(vm.imageHash) {
                vm.image_exists = true;
                vm.state = init ? vm.states.previousImage : vm.states.saved;
            } else {
                vm.image_exists = false;
                vm.state = vm.states.noImage;
            }

            return vm.image_exists;
        }

        function emitImageExists(){
            $scope.$emit('uploaded_image_exists', {
                image_exists: vm.image_exists,
                slug: vm.slug,
                image_number: vm.imageNumber,
                type: vm.type
            });
        }

        function emitNewImageUpload(){
            $scope.$emit('new_image_upload', {
                image_exists: vm.image_exists,
                slug: vm.slug,
                image_number: vm.imageNumber,
                type: vm.type
            });
        }

        function emitUploadedImageDeleted(){
            $scope.$emit('uploaded_image_deleted', {
                image_exists: vm.image_exists,
                slug: vm.slug,
                image_number: vm.imageNumber,
                type: vm.type
            });
        }

        function emitUploadedTempImage(){
            $scope.$emit('uploaded_image_temp', {
                image_exists: vm.image_exists,
                temp_slug: vm.tempSlug
            });
        }

    }
})();
